import React from "react"

import useWindowSize from "../../hooks/useWindowSize"

import "./container.scss"

/**
 * The Сontainer is needed to recalculate the screen size for resizes and flips
 * @component
 * @param  {object} props all props
 * @example
 * const props ={ex: 1, ex2: 3}
 * return (
 *  <Container {...props}>
 *      <Child/>
 *      <Child/>
 *  <Container/>
 * )
 */

const Container = ({children, ...props}) => {
  /**
   * is a object with actual window sizes
   */
  const screenSize = useWindowSize()

  return (
    <div
      className="mainContainer"
      style={{
        height: `${screenSize.height}px`,
      }}
    >
      {children}
    </div>
  )
}

export default Container
